import { useAppSelector } from '@/shared/hooks/useStore';
import { selectCurrentProject } from '@/viewmodel/features/project/state/projectSlice';

export function useCurrentProjectIdViewModel(): string | undefined {
  return useAppSelector(selectCurrentProject)?.id;
}
